module.exports = __webpack_public_path__ + "img/ifs_zh.f0c53b87.png";